window.addEventListener('DOMContentLoaded', () =>
{
  const regionButton = document.querySelector('.nav-region__btn');

  if(!regionButton)
  {
    return;
  }

  const regionContainer = document.querySelector('.nav-region');
  const regionList = document.querySelector('.nav-region__wrapper');
  const closeButton = regionList.querySelector('.nav-region__close');

  regionButton.addEventListener('click', () =>
  {
    if(!regionContainer.classList.contains('overlay-visible'))
    {
      openRegions();
    }
    else
    {
      closeRegions();
    }
  });

  const openRegions = () =>
  {
    console.log('123')
    regionList.classList.add('overlay-visible', 'active');
    closeButton.addEventListener('click', closeRegions);
  };

  const closeRegions = () =>
  {
    console.log('321')
    regionList.classList.remove('overlay-visible', 'active');
    closeButton.removeEventListener('click', closeRegions);
  };
});

